module.exports = {
  rootPath: '/hi-direct/',
  cdnPath: '//static.gameplus.qq.com/wap/hi-direct/',
};
